module.exports = __webpack_public_path__ + "static/media/menu-news-selected.fb694238.svg";